import React from 'react';
import Loadable from 'react-loadable';
import { Spin, Icon, notification } from 'antd';

import { $t } from 'src/tools';

function Loading(props) {
  if (props.error) {
    notification.warn({
      message: `${$t('new_version', 'Global')}😃😃.`,
      duration: null,
      description: (
        <span>
          {$t('new_version_tip', 'Global')}
          <a onClick={() => window.location.reload()}>{$t('click_here', 'Global')}</a>
          {$t('reload_new', 'Global')}
        </span>
      ),
    });
  }
  return <Spin size="large" indicator={<Icon type="loading" />} />;
}

const LazyLoad = (loader) => {
  return Loadable({
    loader,
    loading: Loading,
    delay: 300,
  });
};

export default LazyLoad;
